module.exports = __webpack_public_path__ + "img/logo-ligue.8a957a38.jpg";